// extracted by mini-css-extract-plugin
export default {"contact":"styles_contact__cjKtd","contactInfo":"styles_contactInfo__drNqS","contactMainContainer":"styles_contactMainContainer__PFqQE","mobile":"styles_mobile__rcqpU"};